import singaporeImg from "../../../../assets/Places/singapore.png";
import bangkokImg from "../../../../assets/Places/bankok.png";
import parisImg from "../../../../assets/Places/paris.png";
import parisCityImg from "../../../../assets/cities/paris.png";
import tokyoImg from "../../../../assets/Places/tokyo.png";
import lumpurImg from "../../../../assets/Places/lumpur.png";
import londonImg from "../../../../assets/Places/london.png";
import phuketImg from "../../../../assets/Places/phuket.png";
import dubaiImg from "../../../../assets/Places/dubai.png";
import delhiImg from "../../../../assets/cities/delhi.png";

const redFortActivity = {
  title: "Jai Hind Sound & Light Show at the Red Fort in Delhi",
  location: "New Delhi",
  rating: 4.8,
  reviews: 155,
  duration: "1 hour",
  image: delhiImg,
  price: 500,
  oldPrice: 900,
  desc: "The Red Fort sound & light show brings Delhi's history alive with dramatic narration, music, and vivid projections.",
};

export const internationalPlaces = [
  { label: "Singapore", code: "SIN", short: "Singapore" },
  { label: "Bangkok, Thailand", code: "BKK", short: "Bangkok" },
  { label: "Tokyo, Japan", code: "TYO", short: "Tokyo" },
  { label: "Kuala Lumpur, Malaysia", code: "KUL", short: "Kuala Lumpur" },
  { label: "Paris, France", code: "PAR", short: "Paris" },
  { label: "London, United Kingdom", code: "LON", short: "London" },
  { label: "Phuket, Thailand", code: "HKT", short: "Phuket" },
  { label: "Dubai, UAE", code: "DXB", short: "Dubai" },
];

export const internationalChips = [
  { title: "Singapore", code: "SIN", image: singaporeImg },
  { title: "Bangkok", code: "BKK", image: bangkokImg },
  { title: "Tokyo", code: "TYO", image: tokyoImg },
  { title: "Kuala Lumpur", code: "KUL", image: lumpurImg },
  { title: "Paris", code: "PAR", image: parisCityImg },
  { title: "London", code: "LON", image: londonImg },
  { title: "Phuket", code: "HKT", image: phuketImg },
  { title: "Dubai", code: "DXB", image: dubaiImg },
];

export const sortOptions = ["Traveler Rating", "Price (Low to High)", "Price (High to Low)"];

export const filterGroups = [
  { title: "Duration", lines: ["Up to 1 hour", "1 to 4 hours", "4 hours to 1 day", "1 to 3 days", "More than 3 days"] },
  { title: "User Rating", lines: ["5 stars", "4 stars & up", "3 stars & up", "2 stars & up"] },
  { title: "Specials", lines: ["Free Cancellation", "Skip The Line", "Private Tour", "Special Offer"] },
];

const singaporeActivities = [
  {
    title: "Lion City Bike Tour of Singapore",
    location: "Singapore",
    rating: 4.9,
    reviews: 4521,
    duration: "4 hours",
    image: singaporeImg,
    price: 5234,
    oldPrice: 6900,
    desc: "Join a relaxed historical and sightseeing bike tour through Singapore's best-known streets, neighborhoods, and local stories.",
  },
  {
    title: "Historical Singapore Bike Tour on Full-Sized Bicycles",
    location: "Singapore",
    rating: 4.9,
    reviews: 1179,
    duration: "4 hours",
    image: bangkokImg,
    price: 9774,
    oldPrice: 11800,
    desc: "Ride award-winning licensed bikes through Singapore with a small group, local guide, and cultural highlights along the route.",
  },
  {
    title: "Experience Singapore: Cultural Cooking Class",
    location: "Singapore",
    rating: 4.8,
    reviews: 1048,
    duration: "3 hours",
    image: parisImg,
    price: 8020,
    oldPrice: 9600,
    desc: "Learn Singapore's food culture in a hands-on cooking class and prepare local family recipes with guided instruction.",
  },
  {
    title: "Singapore Food & Bike Tour - Katong",
    location: "Singapore",
    rating: 4.8,
    reviews: 225,
    duration: "4 hours",
    image: singaporeImg,
    price: 7408,
    oldPrice: 9200,
    desc: "Cycle through Katong and discover Singapore's food culture, hidden local delicacies, colorful streets, and neighborhood stories.",
  },
  {
    title: "SG Arrival: Changi Airport Transfer to Hotels / Residence",
    location: "Singapore",
    rating: 4.7,
    reviews: 178,
    duration: "20 to 45 minutes",
    image: bangkokImg,
    price: 6109,
    oldPrice: 7800,
    desc: "Travel from Changi Airport to your hotel in a comfortable private van with luggage space and smooth arrival assistance.",
  },
  {
    title: "Off the Beaten Track in Singapore: Private City Tour",
    location: "Singapore",
    rating: 4.9,
    reviews: 39,
    duration: "3 hours",
    image: parisImg,
    price: 14455,
    oldPrice: 17000,
    desc: "Explore Singapore like a local through alternative neighborhoods, food stops, cultural corners, and stories away from the usual route.",
  },
];

const bangkokActivities = [
  {
    title: "Old Siam Bangkok Food Tour: 15+ Tastings Included",
    location: "Bangkok",
    rating: 4.9,
    reviews: 547,
    duration: "4 hours",
    image: bangkokImg,
    price: 4807,
    oldPrice: 6200,
    desc: "Explore old Bangkok by boat and on foot while tasting local dishes, hidden snacks, and market favorites with a small group.",
  },
  {
    title: "Private Excursion to Floating Market and Ayutthaya",
    location: "Bangkok",
    rating: 4.8,
    reviews: 331,
    duration: "11 to 12 hours",
    image: parisImg,
    price: 26523,
    oldPrice: 31800,
    desc: "Take a private day trip from Bangkok to a floating market and Ayutthaya with temples, local flavors, and scenic stops.",
  },
  {
    title: "Bangkok Private Instagram Tour: All-Inclusive",
    location: "Bangkok",
    rating: 4.8,
    reviews: 239,
    duration: "6 to 9 hours",
    image: singaporeImg,
    price: 10836,
    oldPrice: 13200,
    desc: "Visit Bangkok's most photogenic temples, streets, and cultural corners with a private guide and all-inclusive planning.",
  },
  {
    title: "Hidden Bangkok Canal Tour: A 2-Hour Journey Through Old Bangkok",
    location: "Bangkok",
    rating: 4.7,
    reviews: 127,
    duration: "2 hours",
    image: bangkokImg,
    price: 2922,
    oldPrice: 3900,
    desc: "Travel by boat through Bangkok's canals, local houses, artist villages, and riverside communities on a short guided tour.",
  },
  {
    title: "Foods experience at Railway & Floating Market",
    location: "Bangkok",
    rating: 4.8,
    reviews: 65,
    duration: "7 hours",
    image: singaporeImg,
    price: 17611,
    oldPrice: 21000,
    desc: "Visit Maeklong Railway Market and Damnoen Saduak Floating Market with guided local food tastings and countryside stops.",
  },
  {
    title: "Erawan Waterfall and Kanchanaburi Private Tour",
    location: "Bangkok",
    rating: 4.8,
    reviews: 50,
    duration: "14 hours",
    image: parisImg,
    price: 35134,
    oldPrice: 42000,
    desc: "Take a private full-day trip to Kanchanaburi and Erawan Waterfall for natural scenery, history, and cultural exploration.",
  },
];

const tokyoActivities = [
  {
    title: "Members-Only Bar-Hopping: Discover Your Secret Tokyo Night",
    location: "Ebisu",
    rating: 4.8,
    reviews: 22,
    duration: "2 hours 30 minutes",
    image: tokyoImg,
    price: 11122,
    oldPrice: 13600,
    desc: "Visit members-only bars and enjoy Japanese whisky, gin, cocktails, and intimate local nightlife with a guided host.",
  },
  {
    title: "1-Day Private Snow Monkey ZenkoJi Temple & Sake Tour",
    location: "Toyama Prefecture",
    rating: 4.8,
    reviews: 22,
    duration: "6 hours",
    image: bangkokImg,
    price: 52553,
    oldPrice: 62000,
    desc: "Travel around Nagano to see snow monkeys, Zenko-ji Temple, local food, sake stops, and scenic winter highlights.",
  },
  {
    title: "1-Day Tour from Nagano and Matsumoto Kamikochi",
    location: "Nagano",
    rating: 4.8,
    reviews: 20,
    duration: "9 hours",
    image: parisImg,
    price: 17140,
    oldPrice: 21000,
    desc: "Explore Central Japan's mountain landscapes, alpine scenery, rivers, and cultural highlights on a guided full-day tour.",
  },
  {
    title: "Let's make only one original onigawara in the world",
    location: "Kyoto",
    rating: 4.8,
    reviews: 14,
    duration: "2 hours 30 minutes",
    image: tokyoImg,
    price: 7300,
    oldPrice: 9200,
    desc: "Create your own original onigawara inspired by Japanese temple roof ornaments and learn about this historic craft tradition.",
  },
  {
    title: "Private Day Tour In Tokyo with a Native English Speaker",
    location: "Tokyo",
    rating: 4.9,
    reviews: 14,
    duration: "3 to 6 hours",
    image: singaporeImg,
    price: 10429,
    oldPrice: 12800,
    desc: "Experience Tokyo like a local with a private customizable tour, guided by a native English speaker around your interests.",
  },
  {
    title: "Early Morning Kayaking With view of Mt Fuji at Kawaguchiko",
    location: "Fujikawaguchiko Machi",
    rating: 4.8,
    reviews: 14,
    duration: "1 hour 30 minutes",
    image: bangkokImg,
    price: 4493,
    oldPrice: 5800,
    desc: "Start the day kayaking on calm lake water with views of Mt Fuji and peaceful morning scenery around Kawaguchiko.",
  },
];

const kualaLumpurActivities = [
  {
    title: "Batu Caves & Kuala Gandah Elephant Sanctuary Full-Day Tour",
    location: "Kuala Lumpur",
    rating: 4.6,
    reviews: 2,
    duration: "7 hours",
    image: lumpurImg,
    price: 10185,
    oldPrice: 12400,
    desc: "Visit Batu Caves and Kuala Gandah Elephant Sanctuary on a small-group tour focused on natural wonders and wildlife care.",
  },
  {
    title: "Kuala Lumpur City Tour (8 hours)",
    location: "Kuala Lumpur",
    rating: 4.7,
    reviews: 2,
    duration: "7 to 8 hours",
    image: singaporeImg,
    price: 8636,
    oldPrice: 10800,
    desc: "Discover Kuala Lumpur's major attractions including Petronas Twin Towers, KL Tower, National Mosque, monuments, and markets.",
  },
  {
    title: "Kuala Lumpur Tower Observation & Sky Deck with City Views",
    location: "Kuala Lumpur",
    rating: 4.6,
    reviews: 1,
    duration: "4 hours",
    image: lumpurImg,
    price: 10246,
    oldPrice: 12600,
    desc: "Enjoy panoramic views from Kuala Lumpur Tower's observation areas and see the city's skyline from a dramatic height.",
  },
];

const parisActivities = [
  {
    title: "1 Day Paris City Tour on River & Land with Louvre Museum",
    location: "Paris",
    rating: 5,
    reviews: 1,
    duration: "8 hour(s) to 10 hour(s) (approx.)",
    image: parisCityImg,
    price: 10616,
    oldPrice: 12900,
    desc: "The 1 Day Paris City Tour by bus is an excellent way to get around the city and explore iconic landmarks with audio commentary.",
  },
  {
    title: "Paris Private Tour with Hotel Pick Up",
    location: "Paris",
    rating: 5,
    reviews: 1,
    duration: "3 hour(s)",
    image: parisImg,
    price: 38805,
    oldPrice: 45200,
    desc: "Paris is beautiful but challenging to visit in a short period of time. Enjoy a private guided tour with hotel pickup included.",
  },
  {
    title: "Private Walking Tour of Montmartre and Sacre-Coeur",
    location: "Paris",
    rating: 5,
    reviews: 1,
    duration: "2 hour(s) to 3 hour(s) (approx.)",
    image: parisCityImg,
    price: 32497,
    oldPrice: 38600,
    desc: "Discover Parisian culture and bohemian dreams in Montmartre. See the Moulin Rouge area and stories of famous artists.",
  },
  {
    title: "Emily in Paris Guided Walking Tour",
    location: "Paris",
    rating: 5,
    reviews: 1,
    duration: "2 hour(s)",
    image: parisImg,
    price: 4014,
    oldPrice: 5200,
    desc: "Step into the enchanting world of Emily in Paris with a guided small-group walking tour through iconic filming locations.",
  },
  {
    title: "Your private photographer in Paris (-;",
    location: "Paris",
    rating: 5,
    reviews: 1,
    duration: "2 hour(s)",
    image: parisCityImg,
    price: 17395,
    oldPrice: 21400,
    desc: "Visit beautiful Paris photo spots including the Eiffel Tower area, bridges, the Louvre Pyramid, and other classic backdrops.",
  },
  {
    title: "From Paris: Chateau de Fontainebleau and Vaux-le-Vicomte",
    location: "Paris",
    rating: 5,
    reviews: 1,
    duration: "6 hour(s) to 7 hour(s) (approx.)",
    image: parisImg,
    price: 17217,
    oldPrice: 20800,
    desc: "Adventure into the French countryside and explore chateau history, gardens, and elegant heritage away from the city bustle.",
  },
];

const londonActivities = [
  {
    title: "Hampstead Village (London) Walking Tour",
    location: "London",
    rating: 5,
    reviews: 1,
    duration: "3 hour(s)",
    image: londonImg,
    price: 16351,
    oldPrice: 19800,
    desc: "Hampstead is London's Favourite Village, known for iconic landmarks, natural heathland, historic homes, streets, and vibrant cafe culture.",
  },
  {
    title: "The Best London Harry Potter Tour",
    location: "London",
    rating: 5,
    reviews: 482,
    duration: "3 hour(s)",
    image: londonImg,
    price: 1579,
    oldPrice: 2400,
    desc: "A great walking tour for families and Harry Potter fans, exploring famous London locations and movie-set stories with a fun guide.",
  },
  {
    title: "Alcatraz Prison Cocktail Experience in London",
    location: "London",
    rating: 5,
    reviews: 477,
    duration: "1 hour(s) 45 minute(s)",
    image: londonImg,
    price: 5198,
    oldPrice: 6900,
    desc: "Inspired by Hollywood movies and TV, this immersive theatrical cocktail bar brings prison stories, orange jumpsuits, and crafted drinks together.",
  },
  {
    title: "London Royal Parks Bike Tour including Hyde Park",
    location: "London",
    rating: 5,
    reviews: 476,
    duration: "4 hour(s)",
    image: londonImg,
    price: 4421,
    oldPrice: 5600,
    desc: "Take the London Royal Parks Bike Tour and visit royal palaces, beautiful parks, and the city's most spectacular landmarks by bicycle.",
  },
  {
    title: "Hidden London Walking Tour",
    location: "London",
    rating: 5,
    reviews: 285,
    duration: "1 hour(s) 30 minute(s)",
    image: londonImg,
    price: 1894,
    oldPrice: 2700,
    desc: "Take an extraordinary walking tour through the nooks and crannies of old London, uncovering overlooked, forgotten, and hidden spots.",
  },
  {
    title: "Eating London: Twilight Soho Food & Drinks Tour",
    location: "London",
    rating: 5,
    reviews: 283,
    duration: "3 hour(s) 30 minute(s)",
    image: londonImg,
    price: 14631,
    oldPrice: 17800,
    desc: "Welcome to Soho, London's epicenter of flavor and fun, with a dynamic food and drinks tour through Chinatown and iconic local stops.",
  },
];

const phuketActivities = [
  {
    title: "Private Airport Transfer Bangkok, Pattaya, Phuket, and More",
    location: "Phuket",
    rating: 5,
    reviews: 3,
    duration: "2 hour(s) to 4 hour(s) (approx.)",
    image: phuketImg,
    price: 5403,
    oldPrice: 6800,
    desc: "Enjoy a clean private vehicle for your guest transfer with comfortable seating and smooth views along the way.",
  },
  {
    title: "James Bond Island Day Tour by Longtail Boat",
    location: "Phuket",
    rating: 5,
    reviews: 2,
    duration: "1 day",
    image: phuketImg,
    price: 8775,
    oldPrice: 10900,
    desc: "Travel close to the water by traditional Thai longtail boat to James Bond Island with lunch, sunshine, and canoeing.",
  },
  {
    title: "Maya Bay, Phi Phi & Bamboo Island Premium Trip by Speedboat",
    location: "Phuket",
    rating: 5,
    reviews: 2,
    duration: "8 hour(s) to 9 hour(s) (approx.)",
    image: phuketImg,
    price: 8187,
    oldPrice: 9900,
    desc: "Enjoy a premium Phuket speedboat trip to Phi Phi Islands and Bamboo Island with snorkeling, white sand, and crystal-clear water.",
  },
  {
    title: "Phi Phi Khai Islands Snorkeling By Premium Speedboat",
    location: "Phuket",
    rating: 5,
    reviews: 2,
    duration: "9 hour(s)",
    image: phuketImg,
    price: 6029,
    oldPrice: 7600,
    desc: "Explore Phi Phi Don and Phi Phi Lay with the idyllic Khai Nai Island on a memorable snorkeling trip through this archipelago.",
  },
  {
    title: "Jet Ski Trip Halfday in Phuket",
    location: "Phuket",
    rating: 5,
    reviews: 2,
    duration: "4 hour(s) to 5 hour(s) (approx.)",
    image: phuketImg,
    price: 24313,
    oldPrice: 28900,
    desc: "Visit tourist attractions and snorkel around Khai Island in one day, enjoying Phuket's sea views and a lively jet ski adventure.",
  },
  {
    title: "James Bond Island and Phang Nga Bay Tour By Big Boat",
    location: "Phuket",
    rating: 5,
    reviews: 2,
    duration: "7 hour(s)",
    image: phuketImg,
    price: 4740,
    oldPrice: 6100,
    desc: "Discover spectacular scenery in Phang Nga Bay by luxury big boat, with canoeing around Panak Island and memorable island views.",
  },
];

const dubaiActivities = [
  {
    title: "Dubai: Unique SUNSET Buggy Red Dunes Safari",
    location: "Dubai",
    rating: 5,
    reviews: 21,
    duration: "6 hour(s) to 7 hour(s) (approx.)",
    image: dubaiImg,
    price: 15399,
    oldPrice: 18400,
    desc: "Experience a red dunes safari with camp, dinner, show, and a powerful buggy ride across the desert at sunset.",
  },
  {
    title: "Old Dubai Walking Tour: Abra ride, Creek, Spice & Gold Souks",
    location: "Dubai",
    rating: 5,
    reviews: 21,
    duration: "2 hour(s)",
    image: dubaiImg,
    price: 6214,
    oldPrice: 7900,
    desc: "Explore Old Dubai, Al Fahidi Fort, textile, spice and gold souks, narrow alleys, and a traditional abra ride across the creek.",
  },
  {
    title: "Dubai: Top 15 Must-See Dubai Sightseeing Tour in Small Group",
    location: "Dubai",
    rating: 5,
    reviews: 20,
    duration: "5 hour(s)",
    image: dubaiImg,
    price: 3979,
    oldPrice: 5200,
    desc: "Explore Dubai in style with a guided sightseeing tour covering top attractions, cultural flavors, and authentic Arabic shawarma.",
  },
  {
    title: "60Min Jet Ski To Burj Al Arab, Atlantis The Palm",
    location: "Dubai",
    rating: 5,
    reviews: 20,
    duration: "1 hour(s)",
    image: dubaiImg,
    price: 13440,
    oldPrice: 16200,
    desc: "Ride a jet ski along Dubai's iconic landmarks including the Burj Al Arab, Atlantis The Palm, and scenic waterfront views.",
  },
  {
    title: "Morning Desert Safari With Quad Biking Sandboarding",
    location: "Dubai",
    rating: 5,
    reviews: 20,
    duration: "6 hour(s)",
    image: dubaiImg,
    price: 4807,
    oldPrice: 6200,
    desc: "Begin your day with a quad biking adventure across golden desert sands, sandboarding, and an energetic morning safari experience.",
  },
  {
    title: "Dubai Al Khayma Camp Experience with BBQ Dinner",
    location: "Dubai",
    rating: 5,
    reviews: 19,
    duration: "5 hour(s)",
    image: dubaiImg,
    price: 6599,
    oldPrice: 8300,
    desc: "Experience desert life at Al Khayma Camp with camel riding, sunset stargazing, entertainment, and BBQ dinner flavors.",
  },
];

export const activitiesByPlace = {
  SIN: [redFortActivity],
  BKK: [redFortActivity],
  TYO: [redFortActivity],
  KUL: [redFortActivity],
  PAR: [redFortActivity],
  LON: [redFortActivity],
  HKT: [redFortActivity],
  DXB: [redFortActivity],
};

export function formatPrice(value) {
  return `Rs. ${Number(value).toLocaleString("en-IN")}`;
}

function normalize(value) {
  return String(value || "").trim().toLowerCase();
}

export function getActivePlace(querySource) {
  const query = querySource instanceof URLSearchParams
    ? querySource
    : new URLSearchParams(querySource || "");
  const queryCode = query.get("toCode");
  const queryCity = query.get("city");
  const byCode = internationalPlaces.find((place) => place.code === queryCode);
  const byName = internationalPlaces.find((place) => normalize(place.short) === normalize(queryCity));

  return byCode || byName || internationalPlaces[0];
}

export function getInternationalPage(querySource) {
  const activePlace = getActivePlace(querySource);

  return {
    activePlace,
    activities: activitiesByPlace[activePlace.code] || [],
    filterGroups,
    places: internationalPlaces,
    sortOptions,
  };
}

export function getVisibleInternationalActivities(activities, { search = "", sort = "" } = {}) {
  const searchText = normalize(search);
  const filteredActivities = searchText
    ? activities.filter((activity) => normalize(`${activity.title} ${activity.location} ${activity.desc}`).includes(searchText))
    : [...activities];

  if (sort === "Traveler Rating") {
    return filteredActivities.sort((a, b) => b.rating - a.rating || b.reviews - a.reviews);
  }

  if (sort === "Price (Low to High)") {
    return filteredActivities.sort((a, b) => a.price - b.price);
  }

  if (sort === "Price (High to Low)") {
    return filteredActivities.sort((a, b) => b.price - a.price);
  }

  return filteredActivities;
}
